import { Component, OnInit } from "@angular/core";
import { GeneralService } from "../services/general.service";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
} from "@angular/forms";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
})
export class SettingsComponent implements OnInit {
  showSettings = false;
  objectThemeForm: FormGroup;
  objectTheme: any;
  dsTheme: any;
  newAttributeKey: string = "";
  newAttributeValue: any = "";
  themeVariable;
  constructor(public generalService: GeneralService, private fb: FormBuilder) { }

  ngOnInit(): void { }
  startLoading = false;
  addNewTheme() {
    // this.generalService.getDS("ecTheme").subscribe((data: any) => {
    //   data.ecTheme[0].ecTheme_Code = 1;
    //   data.ecTheme[0].ecTheme_Val = JSON.stringify(this.object);
    //   this.generalService.postDs(data).subscribe(
    //     () => this.generalService.dialogSuccess("Enregistré avec succès", true),
    //     (err) => {
    //       console.error("Submission Error:", err);
    //       this.generalService.dialogSuccess("Non enregistré", false);
    //     }
    //   );
    // });
  }
  getDsTheme() {
    this.startLoading = true;
    this.generalService.getDS("ecTheme&val=1").subscribe(async (data: any) => {
      this.dsTheme = data;

      this.startLoading = false;
      this.objectTheme = JSON.parse(data.ecTheme[0].ecTheme_Val);
      console.log(this.objectTheme);
      await this.fraisLivraison()
      this.initializeForm();
    });
  }
  async getDs() {
    return await this.generalService.getDS("ecTheme&val=1").toPromise();
  }
  checkLength(subKey: string, key: string, index): boolean {
    const control = this.objectThemeForm.value[key][index][subKey];
    if (control) {
      return control.toString().length > 100;
    }
    return false;
  }

  initializeForm() {
    this.objectThemeForm = this.fb.group({});
    Object.keys(this.objectTheme).forEach((key) => {
      const value = this.objectTheme[key];
      this.addControlToForm(key, value);
    });
    this.disbaleSomeInput();
  }
  init() {
    this.showSettings = true;
    setTimeout(() => {
      this.getDsTheme();
      this.themeVariable = this.getDs();
    }, 0);
  }
  controlsToDisable = [
    "name_website",
    "navbar_items",
    "redirectPage",
    "second_logo",
    "first_logo",
    "dashbord",
  ];
  disbaleSomeInput() {
    this.controlsToDisable.forEach((controlName) => {
      const control = this.objectThemeForm.get(controlName);
      if (control) {
        control.disable();
      }
    });
  }
  enableSomeInput() {
    this.controlsToDisable.forEach((controlName) => {
      const control = this.objectThemeForm.get(controlName);
      if (control) {
        control.enable();
      }
    });
  }
  isArrayControl(key: string, subKey?: string): boolean {
    console.log(key, subKey)
    console.log(this.getInputType(subKey))
    if (
      this.getInputType(key) == 'array'
    ) {
      return true;
    } else return null;
  }
  checkInputsBeforeGenerate(param) {
    if (
      this.getInputType(param) == 'array'
    ) {
      return false;
    } else return true;
  }
  addControlToForm(key: string, value: any) {
    if (Array.isArray(value)) {
      const arrayGroup = this.fb.array(
        value.map((item) => this.createFormGroup(item))
      );
      this.objectThemeForm.addControl(key, arrayGroup);
    } else if (typeof value === "object" && value !== null) {
      const group = this.fb.group({});
      Object.keys(value).forEach((subKey) => {
        group.addControl(subKey, this.fb.control(value[subKey]));
      });
      this.objectThemeForm.addControl(key, group);
    } else {
      this.objectThemeForm.addControl(key, this.fb.control(value));
    }
  }

  createFormGroup(item: any): FormGroup {
    const group = this.fb.group({});
    Object.keys(item).forEach((subKey) => {
      group.addControl(subKey, this.fb.control(item[subKey]));
    });
    return group;
  }

  isFormGroup(control: AbstractControl): control is FormGroup {
    return control instanceof FormGroup;
  }
  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }
  getInputType(key: string, parentKey?: string): string {
    const value = parentKey
      ? this.objectTheme[parentKey]
      : this.objectTheme[key];

    if (Array.isArray(value)) {
      return "array";
    } else {
      return this.determineInputType(value);
    }
  }

  private determineInputType(value: any): string {
    if (typeof value === "boolean") {
      return "checkbox";
    } else if (typeof value === "number") {
      return "number";
    } else if (typeof value === "string") {
      return "text";
    } else if (typeof value === "object" && value !== null) {
      return "nested";
    } else {
      return "text";
    }
  }

  addNewAttribute() {
    console.log(this.newAttributeKey)
    if (this.newAttributeKey && this.newAttributeValue !== undefined) {
      let parsedValue: any = this.parseAttributeValue(this.newAttributeValue);
      this.objectTheme[this.newAttributeKey] = parsedValue;

      this.objectThemeForm.addControl(
        this.newAttributeKey,
        this.fb.control(parsedValue)
      );

      this.newAttributeKey = "";
      this.newAttributeValue = "";
    } else {
      this.generalService.dialogSuccess("Une erreur se produite", false);
    }
  }

  parseAttributeValue(value: string) {
    if (value.toLowerCase() === "true") {
      return true;
    } else if (value.toLowerCase() === "false") {
      return false;
    } else if (!isNaN(Number(value))) {
      return Number(value);
    }
    return value;
  }

  onSubmit() {
    this.generalService.getDS("ecTheme&val=1").subscribe((data: any) => {
      this.enableSomeInput();
      data.ecTheme[0].ecTheme_Val = JSON.stringify(this.objectThemeForm.value);
      this.generalService.postDs(data).subscribe(
        () => this.generalService.dialogSuccess("Enregistré avec succès", true),
        (err) => {
          console.error("Submission Error:", err);
          this.generalService.dialogSuccess("Non enregistré", false);
        }
      );
    });
  }
  async fraisLivraison() {
    this.objectTheme['fraisLivraison'] = []
    return new Promise<void>((resolve) => {
      this.generalService.rechercheTable("recherche/tbdata?tablere=FraisLiv").subscribe((data: any) => {
        console.log(data);
        data.forEach(element => {
          this.objectTheme['fraisLivraison'].push(element);
        });
        console.log(this.objectTheme);
        resolve();
      });
    });
  }
}
